import React from 'react';

const AboutSmall = () => {
    const services = [
        {
            title: "Web Development",
            description: "We build responsive and robust web applications tailored to your business needs.",
            hoverText: "Cutting-edge web solutions for your growth.",
            bgImage: "url('/images/h1.jpg')"
        },
        {
            title: "Mobile Apps",
            description: "Custom mobile app development for Android and iOS platforms.",
            hoverText: "Engage your customers on the go.",
            bgImage: "url('/images/h2.jpg')"
        },
        {
            title: "Cloud Solutions",
            description: "Scalable and secure cloud services for modern businesses.",
            hoverText: "Empower your business with the cloud.",
            bgImage: "url('/images/h3.jpg')"
        }
    ];

    const [hoveredIndex, setHoveredIndex] = React.useState(null);

    return (
        <>
        
        <div className='col-md-12 row bg-dark text-white p-4' style={{ borderRadius: 12 }}>

              <div id='technology' className='col-md-12 text-center mt-4'>
                <h4>Technologies We Use</h4>
                <div className='d-flex justify-content-center flex-wrap mt-3'>
                    {/* Flip Box Technology Cards */}
                                {[
                                    { icon: <i className="fab fa-react" style={{fontSize:36}}></i>, name: "ReactJS", desc: "Modern UI library for building fast web apps." },
                                    { icon: <i className="fab fa-node-js" style={{fontSize:36}}></i>, name: "NodeJS", desc: "Scalable backend with JavaScript runtime." },
                                    { icon: <i className="fab fa-aws" style={{fontSize:36}}></i>, name: "AWS", desc: "Cloud infrastructure and deployment." },
                                    { icon: <i className="fab fa-js-square" style={{fontSize:36}}></i>, name: "JavaScript", desc: "Core language for web development." },
                                    { icon: <i className="fab fa-python" style={{fontSize:36}}></i>, name: "Python", desc: "Versatile language for backend and automation." },
                                    { icon: <i className="fab fa-android" style={{fontSize:36}}></i>, name: "Android", desc: "Mobile app development platform." },
                                    { icon: <i className="fab fa-php" style={{fontSize:36, color:'#777bb4'}}></i>, name: "PHP", desc: "Popular server-side scripting language." },
                                    { icon: <i className="fab fa-laravel" style={{fontSize:36, color:'#ff2d20'}}></i>, name: "Laravel", desc: "Elegant PHP framework for web artisans." },
                                    { icon: <i className="fab fa-wordpress" style={{fontSize:36, color:'#21759b'}}></i>, name: "WordPress", desc: "Leading CMS for websites and blogs." },
                                    { icon: <i className="fas fa-database" style={{fontSize:36, color:'#4db33d'}}></i>, name: "MongoDB", desc: "NoSQL database for modern apps." },
                                    { icon: <i className="fas fa-database" style={{fontSize:36, color:'#00758f'}}></i>, name: "MySQL", desc: "Reliable open-source relational database." },
                                    { icon: <i className="fab fa-microsoft" style={{fontSize:36, color:'#0078d4'}}></i>, name: "ASP.NET C#", desc: "Robust framework for enterprise apps." },
                                    { icon: <i className="fab fa-microsoft" style={{fontSize:36, color:'#512bd4'}}></i>, name: ".NET Core", desc: "Cross-platform .NET development." },
                                    { icon: <i className="fab fa-vuejs" style={{fontSize:36, color:'#42b883'}}></i>, name: "VueJS", desc: "Progressive JavaScript framework." },
                                    { icon: <i className="fab fa-angular" style={{fontSize:36, color:'#dd0031'}}></i>, name: "Angular", desc: "TypeScript-based web application framework." },
                                    { icon: <i className="fab fa-apple" style={{fontSize:36, color:'#333'}}></i>, name: "iOS", desc: "Mobile app development for Apple devices." }
                                ].map((tech, idx) => (
                                    <div
                                        key={tech.name}
                                        className="flip-box m-2"
                                        style={{
                                            width: 150,
                                            height: 150,
                                            perspective: 1000,
                                            display: 'inline-block'
                                        }}
                                    >
                                        <div className="flip-box-inner"
                                            style={{
                                                position: 'relative',
                                                width: '100%',
                                                height: '100%',
                                                textAlign: 'center',
                                                transition: 'transform 0.6s',
                                                transformStyle: 'preserve-3d'
                                            }}
                                        >
                                            <div className="flip-box-front"
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    backfaceVisibility: 'hidden',
                                                    background: '#fff',
                                                    borderRadius: 12,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: 18,
                                                    color: '#222'
                                                }}
                                            >
                                                {tech.icon}
                                                <div style={{marginTop: 12, fontWeight: 'bold'}}>{tech.name}</div>
                                            </div>
                                            <div className="flip-box-back"
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    backfaceVisibility: 'hidden',
                                                    background: '#222',
                                                    color: '#fff',
                                                    borderRadius: 12,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: 15,
                                                    transform: 'rotateY(180deg)',
                                                    padding: 12
                                                }}
                                            >
                                                <div style={{marginBottom: 8, fontWeight: 'bold'}}>{tech.name}</div>
                                                <div>{tech.desc}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                
                
            </div>
            {/* Left Section: Heading */}
            <div className='col-md-6 text-center'>
                <h4>Our Company</h4>
                <h2>MINIX IT HUB is your trusted source in IT services and support</h2>
            </div>
            {/* Right Section: Content */}
            <div className='col-md-6 text-justify'>
                <p
                    style={{
                        marginTop: 24,
                        animation: 'fadeInText 1s ease'
                    }}
                >
                    Innovation, creativity, quality and promptness are the main aim of “Minix IT Hub” and we imbibe these aim mantras in our work, to the core. Minix IT Hub provides comprehensive online solutions that integrate website designs, development, eCommerce solutions enables online players to create cohesive and seamless experience for their recurring and prospective clients. Based in Jaipur, Rajasthan,Minix IT Hub is a forthright Website Designing and Web Development Company in the country and globally acclaimed for its professional approach and consistency.
                </p>
            </div>

            <div
                id='service'
                className='col-md-12 row mt-4'
                style={{
                    animation: 'slideUpSection 0.9s cubic-bezier(0.23, 1, 0.32, 1)'
                }}
            >
                {services.map((service, idx) => (
                    <div
                        key={service.title}
                        className='col-md-4 d-flex flex-column justify-content-end align-items-center service-section'
                        style={{
                            backgroundImage: service.bgImage,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            minHeight: '250px',
                            borderRadius: '12px',
                            margin: '16px 0', // Increased margin for more space between cards
                            padding: '10px',
                            position: 'relative',
                            boxShadow: hoveredIndex === idx ? '0 4px 24px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.1)',
                            transition: 'box-shadow 0.3s'
                        }}
                        onMouseEnter={() => setHoveredIndex(idx)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div
                            style={{
                                width: '100%',
                                background: hoveredIndex === idx ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.5)',
                                color: hoveredIndex === idx ? '#ffd700' : '#fff',
                                padding: '24px 12px 16px 12px',
                                borderBottomLeftRadius: '12px',
                                borderBottomRightRadius: '12px',
                                textAlign: 'center',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                transition: 'background 0.3s, color 0.3s',
                                animation: 'fadeInText 1.2s ease'
                            }}
                        >
                            <h4 style={{ marginBottom: 8 }}>{service.title}</h4>
                            <p style={{ margin: 0, fontWeight: hoveredIndex === idx ? 'bold' : 'normal' }}>
                                {hoveredIndex === idx ? service.hoverText : service.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
            <style>{`
                @keyframes fadeInText {
                    from { opacity: 0; transform: translateY(20px);}
                    to { opacity: 1; transform: translateY(0);}
                }
                @keyframes slideUpSection {
                    from { opacity: 0; transform: translateY(60px);}
                    to { opacity: 1; transform: translateY(0);}
                }
            `}</style>
          
            {/* Flip box hover effect styles */}
            <style>{`
                .flip-box:hover .flip-box-inner {
                    transform: rotateY(180deg);
                }
            `}</style>

           
        </div>
         <div id='industry' className='col-md-12 text-center bg-dark'>
                <h4 className='text-white'> Industries We Serve</h4>
                <div className="d-flex justify-content-center flex-wrap mt-3">
                    {[
                        { icon: <i className="fas fa-hospital-alt" style={{fontSize:32, color:'#17a2b8'}}></i>, name: "Healthcare" },
                        { icon: <i className="fas fa-graduation-cap" style={{fontSize:32, color:'#007bff'}}></i>, name: "Education" },
                        { icon: <i className="fas fa-shopping-cart" style={{fontSize:32, color:'#28a745'}}></i>, name: "E-Commerce" },
                        { icon: <i className="fas fa-university" style={{fontSize:32, color:'#6f42c1'}}></i>, name: "Finance" },
                        { icon: <i className="fas fa-plane-departure" style={{fontSize:32, color:'#fd7e14'}}></i>, name: "Travel" },
                        { icon: <i className="fas fa-car" style={{fontSize:32, color:'#343a40'}}></i>, name: "Automotive" },
                        { icon: <i className="fas fa-utensils" style={{fontSize:32, color:'#e83e8c'}}></i>, name: "Food & Restaurant" },
                        { icon: <i className="fas fa-home" style={{fontSize:32, color:'#20c997'}}></i>, name: "Real Estate" },
                        { icon: <i className="fas fa-tshirt" style={{fontSize:32, color:'#ffc107'}}></i>, name: "Fashion" },
                        { icon: <i className="fas fa-bolt" style={{fontSize:32, color:'#dc3545'}}></i>, name: "Energy" }
                    ].map((industry, idx) => (
                        <div
                            key={industry.name}
                            className="industry-card m-3"
                            style={{
                                width: 140,
                                height: 110,
                                background: '#fff',
                                borderRadius: 12,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                cursor: 'pointer',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                        >
                            <div className="industry-icon" style={{marginBottom: 10}}>
                                {industry.icon}
                            </div>
                            <div style={{fontWeight: 600, fontSize: 16}}>{industry.name}</div>
                        </div>
                    ))}
                </div>
                {/* Industry card hover effect */}
                <style>{`
                    .industry-card:hover {
                        transform: translateY(-8px) scale(1.05);
                        box-shadow: 0 8px 24px rgba(0,0,0,0.18);
                        background: linear-gradient(120deg, #f8fafc 60%, #e3f2fd 100%);
                    }
                    .industry-icon {
                        transition: transform 0.3s;
                    }
                    .industry-card:hover .industry-icon {
                        transform: scale(1.2) rotate(-8deg);
                    }
                `}</style>
            </div>
            </>
    );
};

export default AboutSmall;